import axios from "axios";
import { getValidToken } from "../../utils/authUtils";

export const fixedIncomeApi = {
  createContract: async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journeys`;
      const token = await getValidToken();
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  getAllContractDetails: async (type:string, filters?: {
    vehicleNumber?: string;
    startDate?: string;
    routeFrom?: string;
    routeTo?: string;
  }) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journeys/${type}`;
      const token = await getValidToken();
      
      // Build URL search params from filters
      const searchParams = new URLSearchParams();
      if (filters?.vehicleNumber) {
        searchParams.append('vehicleNumber', filters.vehicleNumber);
      }
      if (filters?.startDate) {
        searchParams.append('startDate', filters.startDate);
      }
      if (filters?.routeFrom) {
        searchParams.append('routeFrom', filters.routeFrom);
      }
      if (filters?.routeTo) {
        searchParams.append('routeTo', filters.routeTo);
      }
      
      const urlWithParams = searchParams.toString() 
        ? `${url}?${searchParams.toString()}` 
        : url;
      
      const response = await axios.get(urlWithParams, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  getContractDetails: async (id: string) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journeys/${id}`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  updateContract: async (id: string, data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journeys/${id}`;
      const token = await getValidToken();
      const response = await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  createIncome: async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-incomes`;
      const token = await getValidToken();
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  getIncomeDetailByJourneyId: async (journeyId: string) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-incomes/${journeyId}`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  updateIncome: async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-incomes`;
      const token = await getValidToken();
      const response = await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  deleteIncome: async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-incomes/bulk-soft-delete`;
      const token = await getValidToken();
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  async getDeletedIncomeDetails(id: string) {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-incomes/deleted-income/${id}`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  },

  search: async (searchTerm: string) => {
    try {
      const url = `${
        process.env.REACT_APP_API_HOST
      }master-data/clients?search=${encodeURIComponent(searchTerm)}`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  },

  createPayment: async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-incomes/bulk-create-payments`;
      const token = await getValidToken();
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  updatePayment: async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-incomes/bulk-update-payments`;
      const token = await getValidToken();
      const response = await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  deletePayment: async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-incomes/bulk-delete-payments`;
      const token = await getValidToken();
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  getDeletedIncomePaymentDetails: async (id: string) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-incomes/deleted-income-payments/${id}`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  },

  //Expense
  createBulkExpense: async (data: any, fixedJourneyId: string) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-expenses/bulk/${fixedJourneyId}`;
      const token = await getValidToken();
      const response = await axios.post(
        url,
        { expenses: data },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  getExpenseDetails: async (fixedJourneyId: string) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-expenses/${fixedJourneyId}`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  updateBulkExpense: async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-expenses/bulk-update`;
      const token = await getValidToken();
      const response = await axios.put(
        url,
        { expenses: data },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  deleteBulkExpense: async (data: any, fixedJourneyId: string) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-expenses/bulk/soft-delete/${fixedJourneyId}`;
      const token = await getValidToken();
      const response = await axios.post(
        url,
        { expenses: data },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  getDeletedExpenseDetails: async (fixedJourneyId: string) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-expenses/deleted/${fixedJourneyId}`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  },

  bulkCreateExpensePayment: async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-expenses/bulk/payments/create-payments`;
      const token = await getValidToken();
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  bulkUpdateExpensePayment: async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-expenses/bulk/payments/update-payments`;
      const token = await getValidToken();
      const response = await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  bulkDeleteExpensePayment: async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-expenses/bulk/payments/delete-payments`;
      const token = await getValidToken();
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return response?.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },

  // Daily logs api
  createDailyLog: async (data: any, fixedJourneyId: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-daily-logs/${fixedJourneyId}`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error creating daily log", error);
      return null;
    }
  },
  updateDailyLog: async (id: string, data: any) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-daily-logs/${id}`;
      const response = await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error updating daily log", error);
      return null;
    }
  },
  getDailyLogs: async (fixedJourneyId: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-daily-logs/${fixedJourneyId}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error getting daily logs", error);
      return [];
    }
  },
  softDeleteDailyLog: async (fixedJourneyId: string, data: any) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-daily-logs/soft-delete/${fixedJourneyId}`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error soft deleting daily log", error);
      return null;
    }
  },
  getSoftDeletedDailyLogs: async (fixedJourneyId: string) => {
    try {
      const token = await getValidToken();
      const url = `${process.env.REACT_APP_API_HOST}fixed-journey-daily-logs/deleted/${fixedJourneyId}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data?.isSuccess) {
        return response.data?.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error getting soft deleted daily logs", error);
      return [];
    }
  },

  fetchVehicles: async () => {
    try {
      const token = await getValidToken();
      const queryParams = new URLSearchParams({
        page: "1",
        limit: "100", // Get more vehicles for autocomplete
        status: "Available",
      });

      const url = `${process.env.REACT_APP_API_HOST}vehicles?${queryParams}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data?.isSuccess) {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      return [];
    }
  },
};
